import { render, staticRenderFns } from "./ProjectQuestionariesContainer.vue?vue&type=template&id=728d10c4&scoped=true&"
import script from "./ProjectQuestionariesContainer.vue?vue&type=script&lang=js&"
export * from "./ProjectQuestionariesContainer.vue?vue&type=script&lang=js&"
import style0 from "./ProjectQuestionariesContainer.vue?vue&type=style&index=0&id=728d10c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728d10c4",
  null
  
)

export default component.exports